export default __webpack_public_path__ + "static/media/claimsTab.b79ca562.svg";